<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-label="ariaLabel"
    :height="height"
    :width="width"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style="fill:#FFFFFF;"
      d="M50,8c0-0.4,0-0.9-0.1-1.4c-1.3-3.5-3.5-5.5-7-6.2c-1.5-0.4-3-0.5-4.3-0.5L31.8,0
      c-5.9,0.3-10.2,0.3-12.9-0.1l-2.4-0.1c-1.3,0-2.8,0-4.6,0.1C9.9,0,8.3,0.2,7.3,0.3c-2,0.1-3.7,1.1-4.8,2.8c-0.6,0.9-1,1.8-1.3,2.6
      c-0.6,2.1-0.9,3.9-0.9,5.5c-0.1,2.3-0.1,4.3,0,6c0.1,1.3,0.1,3.6,0.1,7.4L0.3,38.8c0,0.8,0.1,1.8,0.3,3.1c0.3,1.4,0.8,2.6,1.5,3.6
      c0.4,0.5,1,1.3,2,2.1c1.8,1.6,3.8,2.3,6.3,2L23.3,49c0.5,0,3.2,0.1,7.7,0.3c2.3,0.1,5.7,0.1,10.4,0.1h1.9c1.6-0.1,3-0.8,4.2-1.8
      s1.9-2.3,2.3-3.9c0.3-1,0.3-2.8,0.3-5.3c-0.1-2.5-0.1-4-0.1-4.8c0.1-2.8,0.3-6.2,0.1-10.1L50,8z"
    />
    <path
      style="fill:#231F20;"
      d="M43,0.5C41.3,0.2,39.9,0,39,0c-2.8,0-4.9,0-6.3,0.1c-1.5,0.1-3.4,0.3-5.6,0.3c-2.4,0-4.3,0-5.6,0
      c-0.6,0-1,0-1.4-0.1C18.8,0,16.9-0.1,14.6,0c-3.3,0.3-5.8,0.4-7.5,0.5C4.8,0.7,3,1.8,1.9,3.9C1.6,4.3,1.4,4.9,1,5.8
      c-0.5,1.8-0.9,3.5-1,5.5c0,3.4,0,5.7,0.1,6.5c0.1,1.4,0.1,3.4,0.1,6L0.1,38.5c0,0.8,0.1,1.9,0.3,3.5c0.1,1.5,0.8,2.9,1.8,4.3
      c0.4,0.5,1,1.1,1.9,1.9c1.6,1.5,3.5,2.1,5.8,1.9l6.1-0.4c2-0.3,4.6-0.3,7.5-0.3c0.6,0,3,0.1,7.5,0.3c2.3,0.1,5.7,0.1,10.4,0.1h1.5
      c1.8-0.1,3.2-0.8,4.4-1.8c1.1-1,1.9-2.4,2.3-4c0.3-1.4,0.4-3.1,0.1-5.2c-0.1-1.9-0.1-3.4,0-4.8c0.3-2.1,0.4-4.9,0.3-8.4L50,9.1
      c0-2-0.8-3.9-2-5.3C46.6,1.9,45,0.9,43,0.5 M30.8,1.5l8.6-0.1c1.3,0,2.5,0.1,3.7,0.5c1.8,0.4,3.2,1.4,4.2,2.8
      c0.9,1.3,1.4,2.8,1.4,4.3v0.8c-0.1,2.1-0.3,4.8-0.3,7.9l-0.1,13.7c-0.1,3.5-0.1,6.2,0,7.8c0.1,0.9,0.1,1.6,0,2.4
      c0,0.5,0,1.1-0.1,1.5c-0.6,3-2.4,4.5-5.6,4.8L32,47.7c-1.4,0-2.4,0-3.2-0.1c-3.7-0.3-7.5-0.3-11.1,0l-8.5,0.6
      c-1.4-0.1-2.7-0.5-3.7-1.4L4,45.4c-1.1-1.1-1.9-2.8-2.1-4.8L1.7,11.6c0-1.1,0.1-2.8,0.6-4.8c0.4-1.6,1-2.9,1.8-3.8s1.8-1.4,2.8-1.4
      c3.4-0.4,5.9-0.5,7.6-0.5C20,1.7,25.4,1.7,30.8,1.5z"
    />
    <path
      style="fill:#37B250;"
      d="M41.1,19.4c-0.3-1-0.7-1.8-1-2.3c-1.4-2.1-2.3-3.4-2.7-3.9l-3.9-2.9c-0.6-0.4-1.3-0.8-2.2-1.1
      c-0.9-0.3-1.4-0.5-1.8-0.6c-0.6-0.2-1.8-0.5-3.7-0.8c-1.3-0.3-2.7-0.2-4.2,0.3c-1.6,0.4-2.9,1-3.9,2l-1.2,0.8
      c-0.7,0.4-1.1,0.6-1.3,0.6c-0.1,0-0.9-0.5-2.3-1.6c-1.3-0.9-2.1-1.3-2.4-1c0.1,0.2,0.1,0.5,0.1,1.1c0,0.3,0,0.7-0.1,1.2l0.1,1.4
      c0.1,1,0.3,3.4,0.5,7.1c0.1,0.5,0.2,0.8,0.4,0.9c0.3,0.1,1.2,0.1,2.7-0.1c1.3-0.2,2.9-0.4,4.8-0.5l4.3-0.3c0.2-0.3-0.1-0.9-0.9-1.7
      c-0.9-0.9-1.4-1.4-1.5-1.6c0.3-0.3,0.8-0.7,1.6-1.1c0.8-0.4,1.3-0.6,1.6-0.6c3.1,0,5.4,0.7,7.1,2.2c1.3,1.1,2.3,2.4,3.1,4
      c0.2,0.5,0.4,1.1,0.4,1.9c0,0.4,0,1,0,1.8c0.1,1.2-0.2,2.4-0.8,3.7c-0.7,1.5-1.3,2.5-1.7,2.9L30.1,33c-1.5,1.2-3.1,1.9-4.8,2.2
      c-1.8,0.3-3.4,0-4.8-1l-4.1-3.5c-1.2-1.5-1.8-3-1.9-4.6c0-0.5-0.3-0.8-1-1c-0.5-0.1-1.4-0.2-2.7-0.2c-1.2,0-2,0-2.5,0.1
      c-0.5,0.2-0.8,0.5-0.8,1c0,1.1,0.4,2.7,1.2,4.8c0.2,0.8,0.7,1.8,1.3,2.8c0.6,0.9,1.2,1.7,1.9,2.4c2,1.7,3.6,3,4.6,3.6
      c2,1.3,3.9,2.1,5.6,2.3l1.6,0.2c1,0.2,2.9,0.1,5.7-0.2c0.3,0,1-0.2,1.9-0.8c0.8-0.4,1.5-0.8,2-1.1c1.3-0.8,2.4-1.6,3.3-2.4
      c1.3-1.1,2.3-2.1,2.9-3c1-1.5,1.7-3.5,2.3-5.9c0.6-2.7,0.7-4.8,0.2-6.2C42.1,22.2,41.8,21.2,41.1,19.4z"
    />
    <path
      id="Layer0_0_MEMBER_1_MEMBER_0_MEMBER_0_MEMBER_0_MEMBER_0_1_STROKES"
      style="fill:none;stroke:#020303;stroke-miterlimit:10;"
      d="
      M25.9,7.9c-1.3-0.3-2.7-0.2-4.2,0.3c-1.6,0.4-2.9,1-3.9,2l-1.2,0.8c-0.7,0.4-1.1,0.6-1.3,0.6c-0.1,0-0.9-0.5-2.3-1.6
      c-1.3-0.9-2.1-1.3-2.4-1c0.1,0.2,0.1,0.5,0.1,1.1c0,0.3,0,0.7-0.1,1.2l0.1,1.4c0.1,1,0.3,3.4,0.5,7.1c0.1,0.5,0.2,0.8,0.4,0.9
      c0.3,0.1,1.2,0.1,2.7-0.1c1.3-0.2,2.9-0.4,4.8-0.5l4.3-0.3c0.2-0.3-0.1-0.9-0.9-1.7c-0.9-0.9-1.4-1.4-1.5-1.6
      c0.3-0.3,0.8-0.7,1.6-1.1c0.8-0.4,1.3-0.6,1.6-0.6c3.1,0,5.4,0.7,7.1,2.2c1.3,1.1,2.3,2.4,3.1,4c0.2,0.5,0.4,1.1,0.4,1.9
      c0,0.4,0,1,0,1.8c0.1,1.2-0.2,2.4-0.8,3.7c-0.7,1.5-1.3,2.5-1.7,2.9L30.1,33c-1.5,1.2-3.1,1.9-4.8,2.2c-1.8,0.3-3.4,0-4.8-1
      l-4.1-3.5c-1.2-1.5-1.8-3-1.9-4.6c0-0.5-0.3-0.8-1-1c-0.5-0.1-1.4-0.2-2.7-0.2c-1.2,0-2,0-2.5,0.1c-0.5,0.2-0.8,0.5-0.8,1
      c0,1.1,0.4,2.7,1.2,4.8c0.2,0.8,0.7,1.8,1.3,2.8c0.6,0.9,1.2,1.7,1.9,2.4c2,1.7,3.6,3,4.6,3.6c2,1.3,3.9,2.1,5.6,2.3l1.6,0.2
      c1,0.2,2.9,0.1,5.7-0.2c0.3,0,1-0.2,1.9-0.8c0.8-0.4,1.5-0.8,2-1.1c1.3-0.8,2.4-1.6,3.3-2.4c1.3-1.1,2.3-2.1,2.9-3
      c1-1.5,1.7-3.5,2.3-5.9c0.6-2.7,0.7-4.8,0.2-6.2c0-0.1-0.4-1.1-1-3c-0.3-1-0.7-1.8-1-2.3c-1.4-2.1-2.3-3.4-2.7-3.9l-3.9-2.9
      c-0.6-0.4-1.3-0.8-2.2-1.1c-0.9-0.3-1.4-0.5-1.8-0.6C29,8.4,27.8,8.2,25.9,7.9z"
    />
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon],
  props: {
    ariaLabel: {
      type: String,
      default: 'Restart'
    }
  }
};
</script>
